import { UserInfoDto } from 'api/types/core/users';
import { AUTH_GATEWAY_URI, AUTH_LOGOUT_URI } from 'shared/consts/config';
import { toast } from 'shared/hooks/useToast';

export function redirectCognito() {
  toast({ title: 'Authentication was not successful. Redirecting to login page...', variant: 'error' });
  setTimeout(() => window.location.replace(AUTH_GATEWAY_URI), 3000);
}

export function redirectLogout() {
  toast({ title: 'Logging out...', variant: 'info' });
  setTimeout(() => window.location.replace(AUTH_LOGOUT_URI), 2000);
}

export function hasAnyOfRole(userData: UserInfoDto | undefined, roles: string | Array<string>) {
  const userRoles = userData?.roles ?? [];
  return Array.isArray(roles) ? roles.some((r) => userRoles.includes(r)) : userRoles.includes(roles);
}
